exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.user_info[data-v-60f83d25] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n.user_info .ant-row.ant-form-item[data-v-60f83d25] {\n  width: 100%;\n  margin-right: 6px;\n}\n.gx-card-widget .ant-card-head-title[data-v-60f83d25] {\n  padding: 0;\n  text-transform: uppercase;\n  font-size: 16px;\n  font-weight: 600;\n}\n.ant-card-head-title[data-v-60f83d25] {\n  font-weight: 600;\n  font-size: 15px !important;\n}\n", ""]);

// exports
